module.exports = __webpack_public_path__ + "img/Arrow-down-deep-fjord-900.b37ce209.svg";